import classNames from 'classnames';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import * as oPath from '../../../../Lib/Object/Path/Immutable';
import { ILinkProps, Link } from '../../../Core';
import './WorksheetTopLevelLink.scss';

type WorksheetTopLevelLinkProps = ILinkProps & {
  /**
   * Truncates link text to a single line (with an ellipsis)
   * Used to avoid overflow in layouts that do not support it
   */
  truncate?: boolean;
  worksheetPath: string;
};
// Component that provides a link to the "top-level" worksheet for the given worksheet.
const WorksheetTopLevelLink: React.FC<WorksheetTopLevelLinkProps> = ({ truncate, worksheetPath, ...otherProps }) => {
  const topLevelTest = useSelector((s) => oPath.get(s, `${worksheetPath}.syncModel.header.TopLevelTest`), deepEquals);
  const worksheetId = useSelector((s) => oPath.get(s, `${worksheetPath}.syncModel.data.Id`));
  //Note: WorksheetType.ShortName rather than WorksheetType.Caption because we want to avoid
  //making the moisture content dry masses grid any wider than it necessary.
  const shortName = useSelector((s) => oPath.get(s, `${worksheetPath}.syncModel.type.ShortName`));

  return (
    <>
      <div className={classNames('WorksheetTopLevelLink', { 'WorksheetTopLevelLink-truncate': truncate })}>
        {topLevelTest ? (
          <Link to={`/worksheets/${topLevelTest.LinkId}`} {...otherProps}>
            {topLevelTest.WorksheetType.ShortName}
          </Link>
        ) : (
          <Link to={`/worksheets/${worksheetId}`} {...otherProps}>
            {shortName}
          </Link>
        )}
      </div>
    </>
  );
};

export default WorksheetTopLevelLink;
export { WorksheetTopLevelLink };
